import Seo from "@/components/feature/Seo";
import Hero from "@/pages/home/components/Hero";
import CategorySection from "@/pages/home/components/CategorySection";
import HotSection from "@/pages/home/components/HotSection";
import ArticleSection from "@/pages/home/components/ArticleSection";
import BrandBand from "@/pages/home/components/BrandBand";
import FaqSection from "@/pages/home/components/FaqSection";

const siteTitle = "动漫网 - 动漫网官网首页与导航页入口";
const siteDesc =
  "动漫网官网首页与导航页入口，提供动漫网直达链接和网址收藏指引。打开即可快速进入主页，浏览全部频道与分类，无需反复搜索，收藏一次随时访问。";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "动漫网",
    url: "https://animelist8.github.io/",
    logo: "https://animelist8.github.io/vite.svg",
    description: "专注动漫导航与资讯的中文门户网站",
    contactPoint: {
      "@type": "ContactPoint",
      email: "service@dongmanwang.com",
      contactType: "customer service",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "动漫网",
    url: "https://animelist8.github.io/",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://animelist8.github.io/category/all?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: siteTitle,
    url: "https://animelist8.github.io/",
    description: siteDesc,
    inLanguage: "zh-CN",
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "动漫网", item: "https://animelist8.github.io/" },
      ],
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "动漫网是什么？",
        acceptedAnswer: { "@type": "Answer", text: "动漫网是一个专注动漫导航与资讯的中文门户网站，聚合了热血、恋爱、治愈、科幻等八大分类频道，以及热门新番与最新动漫资讯，为动漫爱好者提供一站式浏览体验。" },
      },
      {
        "@type": "Question",
        name: "如何快速进入动漫网主页？",
        acceptedAnswer: { "@type": "Answer", text: "你只需将本页面收藏到浏览器书签即可，动漫网提供直达链接与网址收藏指引，打开收藏即可快速进入主页，浏览全部频道与分类，无需反复搜索。" },
      },
      {
        "@type": "Question",
        name: "动漫网有哪些分类频道？",
        acceptedAnswer: { "@type": "Answer", text: "动漫网覆盖热血、恋爱、治愈、科幻、搞笑、冒险、奇幻、日常八大分类频道，每个频道都聚合了对应题材的动漫推荐与资讯文章。" },
      },
      {
        "@type": "Question",
        name: "动漫网的资讯多久更新一次？",
        acceptedAnswer: { "@type": "Answer", text: "动漫网会持续更新新番前瞻、经典盘点、深度评测等资讯内容，并同步热门新番推荐，让你第一时间掌握动漫圈的最新动态。" },
      },
    ],
  },
];

export default function Home() {
  return (
    <>
      <Seo title={siteTitle} description={siteDesc} keywords="动漫网,动漫网官网首页,动漫网导航页,动漫网直达链接,动漫网入口地址" canonical="/" jsonLd={jsonLd} />
      <Hero />
      <CategorySection />
      <HotSection />
      <ArticleSection />
      <BrandBand />
      <FaqSection />
    </>
  );
}